
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverTrigger } from '@/components/ui/popover';
import { MapPinIcon } from 'lucide-react';
import { LocationOption } from '@/types/weather';
import LocationDropdown from './location/LocationDropdown';
import { useLocationSearch } from '@/hooks/use-location-search';
import { useFavorites } from '@/hooks/use-favorites';

interface LocationSearchProps {
  onSelectLocation: (location: LocationOption) => void;
  selectedLocation?: LocationOption;
}

const LocationSearch: React.FC<LocationSearchProps> = ({ 
  onSelectLocation, 
  selectedLocation 
}) => {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const { locations, isLoading } = useLocationSearch(searchTerm);
  const { favorites, toggleFavorite, isFavorite } = useFavorites();

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button 
          variant="outline" 
          role="combobox" 
          aria-expanded={open} 
          className="justify-between w-full border-2"
        >
          {selectedLocation ? (
            <div className="flex items-center gap-2">
              <MapPinIcon className="h-4 w-4 text-weather-orange" />
              <span>{selectedLocation.name}, {selectedLocation.country}</span>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <MapPinIcon className="h-4 w-4" />
              <span>Select a location</span>
            </div>
          )}
        </Button>
      </PopoverTrigger>
      
      <LocationDropdown
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        locations={locations}
        favorites={favorites}
        selectedLocation={selectedLocation}
        isLoading={isLoading}
        onSelectLocation={onSelectLocation}
        onToggleFavorite={toggleFavorite}
        isFavorite={isFavorite}
        onClose={() => setOpen(false)}
      />
    </Popover>
  );
};

export default LocationSearch;
